import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircleOutlined } from '@ant-design/icons';
import ModalConfirmation from 'components/ModalConfirmation';

const ModalAuthorize = ({
  onAuthorize,
  onCancel,
  content,
  loading,
  open,
}) => (
  <ModalConfirmation
    onFinish={onAuthorize}
    onFinishIcon={<CheckCircleOutlined />}
    onFinishText="Autorizar"
    onCancel={onCancel}
    title="Confirmar Autorización"
    contentTitle={`¿Desea Autorizar ${content}?`}
    subContent="Esta acción no podrá revertirse"
    loading={loading}
    open={open}
  />
);

ModalAuthorize.propTypes = {
  onAuthorize: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  content: PropTypes.string,
  loading: PropTypes.bool,
  open: PropTypes.bool,
};

ModalAuthorize.defaultProps = {
  content: 'el Registro',
  loading: false,
  open: false,
};

export default ModalAuthorize;
